import { Waypoints } from "lucide-react";

export function AppLogo() {
  return (
    <div className="flex items-center gap-2 p-2">
      <Waypoints className="h-7 w-7 text-primary" />
      <h1 className="text-xl font-semibold text-primary">PubSub Monitor</h1>
    </div>
  );
}
